import React from 'react'
import Typography from '@material-ui/core/Typography'
import Fab from '@material-ui/core/Fab'
import ReplayIcon from '@material-ui/icons/Replay'

import PropTypes from 'prop-types'
import SignaturePad from 'react-signature-pad-wrapper'
//import 'moment/dist/locale/es'
//import 'moment/dist/locale/fr'
//import 'moment/dist/locale/pl'
//import 'moment/dist/locale/en-in'
import i18n from 'i18next'

class GetSignature extends React.Component {
  constructor(props) {
    super(props)
    // instance function specifically
    this.toJpeg = async () => {
      return this.sigCanvas.instance.toDataURL('image/jpg')
    }
    this.isEmpty = () => this.sigCanvas.instance.isEmpty()
  }
  render() {
    return (
      <div>
        <Typography variant="body1">{`${this.props.signature}:`}</Typography>
        <div>
          <SignaturePad
            options={{
              penColor: 'darkblue',
              backgroundColor: '#fff'
            }}
            canvasProps={{ className: 'sigCanvas' }}
            ref={(ref) => {
              this.sigCanvas = ref
            }}
          />
          <Fab
            onClick={() => this.sigCanvas.instance.clear()}
            style={{ position: 'absolute', top: '-1rem', right: '-1rem' }}
          >
            <ReplayIcon />
          </Fab>
        </div>
        <Typography variant="body1" className="right">
          {new Intl.DateTimeFormat(i18n.language, { month: 'long', day: 'numeric', year: 'numeric' }).format(new Date())}
        </Typography>
      </div>
    )
  }
}

export default GetSignature

GetSignature.propTypes = {
  signature: PropTypes.string.isRequired
}
